import React from 'react';

// Extracted from LessonWorkspace.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior). A small
// circular icon button with a hover tooltip, shared by the live-session
// pills.
export default function PillBtn({ onClick, title, color, children }) {
  const [show, setShow] = React.useState(false);
  return (
    <div style={{ position: 'relative', flexShrink: 0 }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <button
        onClick={onClick}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: 32, height: 32, border: 'none', borderRadius: 999,
          background: color || 'transparent',
          color: color ? '#fff' : '#444',
          cursor: 'pointer',
          transition: 'background 0.15s ease',
        }}
        onMouseEnter={e => { if (!color) e.currentTarget.style.background = 'rgba(0,0,0,0.06)'; }}
        onMouseLeave={e => { if (!color) e.currentTarget.style.background = 'transparent'; }}
      >
        {children}
      </button>
      {show && title && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', left: '50%',
          transform: 'translateX(-50%)',
          background: 'rgba(30,30,30,0.88)', color: '#fff',
          fontSize: 11, fontWeight: 500,
          padding: '4px 8px', borderRadius: 6,
          whiteSpace: 'nowrap', pointerEvents: 'none',
          zIndex: 99999,
        }}>
          {title}
        </div>
      )}
    </div>
  );
}
